module.exports = __webpack_public_path__ + "img/main.2b5d7a2.png";